<template>
    <div class="container">
        <h1>Upload an Excel File</h1>
        <v-file-input v-model="selectedFile" label="Choose an Excel File"></v-file-input>
        <v-btn @click="uploadFile" color="primary">Upload</v-btn>

        <template>
            <div class="mt-3">
                <v-data-table :headers="headers" :items="items" item-key="id" show-select @item-selected="onItemSelected"
                    :search="search">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field v-model="search" label="Search"></v-text-field>
                            <v-spacer></v-spacer>
                            <v-btn @click="upload" color="primary">upload Bonuses</v-btn>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon @click="editRow(item)" class="mr-2" color="warning">
                            mdi-pencil
                        </v-icon>
                        <v-icon @click="deleteRow(item)" color="error">
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </div>
        </template>
    </div>
</template>
  
<script>
import Papa from 'papaparse';
import { PromoService } from "@/services";
import app from '@/main'


export default {
    data() {
        return {
            selectedFile: null,
            headers: [
                { text: 'First Name', value: 'firstname' },
                { text: 'Last Name', value: 'lastname' },
                { text: 'User Name', value: 'username' },
                { text: 'Email', value: 'email' },
                { text: 'Amount', value: 'amount' },
                { text: 'Trade Type', value: 'trade_type' },
                { text: 'Status', value: 'status' },
            ],
            items: [

            ],
            selectedItems: [],
            search: '',
        };
    },
    methods: {
        uploadFile() {
            this.items = [];
            if (!this.selectedFile) {
                alert("Please select an Excel file.");
                return;
            }
            this.convertCsvToJson(this.selectedFile);



        },
        async upload() {
            app.$store.dispatch('toast', {
                message: 'uploading bonus...',
                variant: 'info'
            });
            console.log("the items here:", this.items);
            let model = [];
            this.items.forEach((i)=>{
                i.user = i.id;
                delete(i.id);
                model.push(i)

            })
        const data = await PromoService.uploadBonus(this.items); 
        if(data){
            app.$store.dispatch('toast', {
                message: 'uploading successful',
                variant: 'success'
            });
        }   
        },

        convertCsvToJson(file) {
            Papa.parse(file, {
                header: true,
                complete: async (results) => {
                    console.log(results.data);
                    let excel = results.data;
                    let emails = [];
                    this.items = []; // Clear the items array

                    excel.forEach(element => {
                        emails.push(element.email);
                    });

                    console.log('emails are showing', emails);
                    app.$store.dispatch('toast', {
                        message: 'verifying content from server',
                        variant: 'info'
                    })
                    const data = await PromoService.getUsersDetails({ emails });
                    console.log(data);
                    if (data) app.$store.dispatch('toast', {
                        message: 'verifying complete',
                        variant: 'success'
                    })
                    data.forEach((element) => {
                        let item = {
                            firstname: element.profile.firstname,
                            lastname: element.profile.lastname,
                            id: element.id,
                            username: element.username,
                            email: element.email,
                        };
                        excel.forEach(excelElement => {
                            if (excelElement.email == item.email) {
                                item.trade_type = excelElement.trade_type;
                                item.amount = excelElement.amount;
                                item.status = excelElement.status;
                            }
                        });
                        this.items.push(item); // Add the item to the items array here
                    });
                }
            });
        }

    },
};
</script>
  